
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { format, isValid } from "date-fns";


export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount: number, options?: Intl.NumberFormatOptions) {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    ...options
  }).format(amount);
}

export function formatDateSafe(dateValue: any, formatString = "dd-MM-yyyy"): string {
  if (!dateValue) return "N/A"; // Handle null or undefined

  let date;
  // Firestore Timestamp
  if (dateValue && typeof dateValue.toDate === 'function') {
    date = dateValue.toDate();
  } else if (dateValue instanceof Date) {
    date = dateValue;
  } else {
    // Handle strings or numbers
    date = new Date(dateValue);
  }

  // Check if the created date is valid
  if (!isValid(date)) {
    return "Invalid Date";
  }

  try {
    return format(date, formatString);
  } catch (error) {
    console.error("Error formatting date:", error);
    return "Invalid Date";
  }
}
